import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";

import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import Features from "./pages/Features";

import SummaryUpload from "./components/SummaryUpload";
import StudyPlanner from "./components/StudyPlanner";
import ChatWindow from "./components/ChatWindow";

import "./App.css";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-50 text-gray-900">
        {/* Top Navbar */}
        <Navbar />

        {/* Main layout */}
        <div className="flex flex-1 pt-16">
          {/* Left Sidebar */}
          <Sidebar />

          {/* Page content */}
          <main className="flex-1 p-6 overflow-y-auto">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/about" element={<About />} />
              <Route path="/features" element={<Features />} />
              <Route path="/summarizer" element={<SummaryUpload />} />
              <Route path="/planner" element={<StudyPlanner />} />
              <Route path="/chat" element={<ChatWindow />} />
            </Routes>
          </main>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
